<template>
  <v-app-bar
    color="#748873"
    elevation="0"
    height="60"
    class="menu-bar"
  >
    <!-- Logo / Título -->
    <v-app-bar-title class="font-weight-regular">
      {{ title }}
    </v-app-bar-title>

    <v-spacer />

    <div class="mr-2 menu-scroll d-flex flex-nowrap">
        <v-menu open-on-hover>
          <template #activator="{ props }">
            <v-btn v-bind="props" text >
              <v-icon start size="18">mdi-bag-suitcase</v-icon>
                Operações
            </v-btn>
          </template>
    
          <v-list density="compact">
            <v-list-item
              title="Venda / Compra"
              prepend-icon="mdi-cash-multiple"
              @click="$router.push('/vendas')"
            />
            <v-list-item
              title="Transferência de estoque"
              prepend-icon="mdi-swap-horizontal"
              @click="$router.push('/transferencias')"
            />
          </v-list>
        </v-menu>

        <!-- Cadastros -->
        <v-menu open-on-hover>
          <template #activator="{ props }">
            <v-btn v-bind="props" text >
              <v-icon start size="18">mdi-folder</v-icon>
                Cadastros
            </v-btn>
          </template>
    
          <v-list density="compact">
            <v-list-item
              title="Clientes"
              prepend-icon="mdi-account-box"
              @click="$router.push('/clientes')"
            />
            <v-list-item
              title="Estoques"
              prepend-icon="mdi-package-variant"
              @click="$router.push('/estoques')"
            />
            <v-list-item
              title="Vendedores"
              prepend-icon="mdi-account-tie"
              @click="$router.push('/vendedores')"
            />
          </v-list>
        </v-menu>
    
        <!-- Produtos -->
        <v-menu open-on-hover>
          <template #activator="{ props }">
            <v-btn v-bind="props" text>
              <v-icon start>mdi-tree</v-icon>
                Produtos
            </v-btn>
          </template>
    
          <v-list density="compact">
            <v-list-item
              title="Produto"
              prepend-icon="mdi-sprout"
              @click="$router.push('/produtos')"
            />
            <v-list-item
              title="Categoria"
              prepend-icon="mdi-pot-mix"
              @click="$router.push('/categorias')"
            />
            <v-list-item
              title="Pote"
              prepend-icon="mdi-pot"
              @click="$router.push('/potes')"
            />
          </v-list>
        </v-menu>
    
        <!-- Financeiro -->
        <v-menu open-on-hover>
          <template #activator="{ props }">
            <v-btn v-bind="props" text>
              <v-icon start>mdi-currency-usd</v-icon>
                Financeiro
            </v-btn>
          </template>
    
          <v-list density="compact">
            <v-list-item
              title="Pagamentos"
              prepend-icon="mdi-credit-card-settings-outline"
              @click="$router.push('/pagamentos')"
            />
          </v-list>
        </v-menu>
    
        <!-- Relatórios -->
        <v-menu open-on-hover>
          <template #activator="{ props }">
            <v-btn v-bind="props" text>
              <v-icon start>mdi-cloud-print-outline</v-icon>
                Relatórios
            </v-btn>
          </template>
    
          <v-list density="compact">
            <v-list-item
              title="Estoque"
              prepend-icon="mdi-package-variant"
              @click="$router.push('/reports/stock')"
            />
            <v-list-item
              title="Vendas/Compras"
              prepend-icon="mdi-credit-card-outline"
              @click="$router.push('/reports/sales')"
            />
          </v-list>
        </v-menu>
    
        <!-- Configurações -->
        <v-menu open-on-hover>
          <template #activator="{ props }">
            <v-btn v-bind="props" text>
              <v-icon start>mdi-cog-outline</v-icon>
                Configurações
            </v-btn>
          </template>
    
          <v-list density="compact">
            <v-list-item
              title="Usuários"
              prepend-icon="mdi-account-edit"
              @click="$router.push('/usuarios')"
            />
          </v-list>
        </v-menu>
    </div>
    <div>
        <!-- Usuário -->
        <v-menu>
          <template #activator="{ props }">
            <v-btn icon v-bind="props">
              <v-icon size="28">mdi-account</v-icon>
            </v-btn>
          </template>
    
          <v-list density="compact">
            <v-list-item :title="user" />
            <v-divider />
            <v-list-item title="Sair" prepend-icon="mdi-logout" @click="logout()"/>
          </v-list>
        </v-menu>
    </div>
  </v-app-bar>

  <v-main style="height: 100vh">
    <router-view />
  </v-main>
</template>

<script>
import { useDisplay } from 'vuetify'

export default {
    setup () {
      const { mobile } = useDisplay()
      return { mobile }
  },
  data: () => ({

  }),
  computed: {
    title() {
        return this.$route.meta.title || ''
    },
    user() {
        return localStorage.getItem('usuario')
    }
  },
  methods: {
    logout() {
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
    }
  }
}
</script>

<style>
.menu-bar .v-btn {
  text-transform: none;
}

.menu-bar .v-icon {
  font-size: 18px;
}

.menu-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  max-width: 100%;
}

.menu-scroll::-webkit-scrollbar {
  display: none;
}

.menu-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.menu-scroll .v-btn {
  flex-shrink: 0;
}
</style>
